import { Link } from 'react-router';
import type { AnchorHTMLAttributes, JSX } from 'react';
import { cn } from '../../../lib/cn.js';

// Link mapping for article prose. Internal app paths ("/blog/…", "/getting-started")
// use the router Link (no full reload); in-page anchors ("#foo") and external URLs
// use a plain <a>. Shared by the MDX `a` mapping and the layout chrome.
type SmartLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const LINK_CLASS =
  'link-underline-draw text-accent-blue focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cyan-400';

export function SmartLink({ href, className, children, ...rest }: SmartLinkProps): JSX.Element {
  const cls = cn(LINK_CLASS, className);

  if (href && href.startsWith('/')) {
    return (
      <Link to={href} className={cls} {...rest}>
        {children}
      </Link>
    );
  }

  const isExternal = !!href && /^https?:/.test(href);
  return (
    <a
      href={href}
      className={cls}
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      {...rest}
    >
      {children}
    </a>
  );
}
